import React from "react";
import { Link } from "react-router-dom";
import { buildGoModernBookingUrl, getGoModernUrls } from "../utils/gomodern";
import { getAttributionParams, trackEvent } from "../lib/analytics";

const footerItems = [
  { label: "Product", path: "/product" },
  { label: "Services", path: "/services" },
  { label: "For CROs", path: "/home#for-cros" },
  { label: "For Founders", path: "/home#for-founders" },
  { label: "Use Cases", path: "/usecases" },
  { label: "Value Creation Teams", path: "/valuecreationteams" },
  { label: "About", path: "/aboutus" },
  { label: "Terms and Conditions", path: "/terms" },
  { label: "Privacy Policy", path: "/privacy" },
];

const Footer = () => {
  const demoUrl = buildGoModernBookingUrl({
    baseUrl: getGoModernUrls().demo,
    sourcePage: "footer",
    ctaClicked: "footer_book_demo",
    requestedOffer: "BestSalesCoach.ai Platform Demo",
    buyerType: "General",
  });

  return (
    <footer className="marketing-footer">
      <div className="marketing-shell marketing-footer-grid">
        <div>
          <h3 className="marketing-footer-title">BestSalesCoach.ai</h3>
          <p className="marketing-footer-copy">
            AI GTM execution intelligence for CROs, founders, RevOps leaders, and GTM teams that need better signal, cleaner handoffs, stronger execution, and more repeatable growth.
          </p>
        </div>

        <nav aria-label="Footer">
          <ul className="marketing-footer-links">
            {footerItems.map((item) => (
              <li key={item.label}>
                <Link className="marketing-footer-link" to={item.path}>
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                className="marketing-footer-link"
                href={demoUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  const attribution = getAttributionParams();
                  const payload = {
                    source_page: "footer",
                    cta_clicked: "footer_book_demo",
                    requested_offer: "BestSalesCoach.ai Platform Demo",
                    buyer_type: "General",
                    destination_url: demoUrl,
                    ...attribution,
                  };
                  trackEvent("book_demo_click", payload);
                  trackEvent("gomodern_form_opened", payload);
                }}
              >
                Book Demo
              </a>
            </li>
          </ul>
        </nav>

        <div className="marketing-footer-meta">
          <p>Contact: admin@bestsalescoach.ai</p>
          <p>© {new Date().getFullYear()} BestSalesCoach.ai</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
